<template>
  <div :class='"dateList role"+curRole'>
      <div class="date" v-for="(item,i) in list" :key='i'>
          <p>{{weekList[item.week]}}</p>
          <p @click='getDays(i)'> <span :class='num==i?"active":""'>{{item.day}}</span></p>
      </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        curRole:this.$store.state.loginUser.currentUserType,//3老师，5家长
        list:[],
        week:'',
        num:6,
        weekList:['周日','周一','周二','周三','周四','周五','周六']
      }
    },
    created(){
      this.getDate();
   },
    methods: {
       getDays(i){
          this.num=i;
          this.$emit('getdays',this.list[i])
      },
      getDate(){
        //设置日期，当前日期的前七天
        var myDate = new Date(); //获取今天日期
        myDate.setDate(myDate.getDate() - 6);
        var dateArray = []; 
        var dateTemp; 
        var flag = 1; 
        for (var i = 0; i < 7; i++) {
          let t1=myDate.getMonth()+1,t2=myDate.getDate();
            dateTemp =myDate.getFullYear()+"-"+ (t1>9?t1:'0'+t1)+"-"+(t2>9?t2:'0'+t2);
            dateArray.push({date:dateTemp,week:myDate.getDay(),day:myDate.getDate()});
            myDate.setDate(myDate.getDate() + flag);
        }
        this.list=dateArray;
      },
    },
  }
</script>
<style lang="scss" >
.dateList{
    position: fixed;
    left: 0px;
    // top: 0px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:6px 0px;
    background:#fff;
    box-shadow: 0px 4px 12px rgba(0,0,0,0.1);
    z-index: 2;
    .date{
      flex:1;
      font-size:.13rem;
      text-align: center;
      span{
        display: inline-block;
        width:.35rem;
        height:.35rem;
        line-height: .35rem;
        border-radius: 50%;
        margin-top: 8px;
        font-size: .15rem;
        font-weight: 700;
        &.active{
          color:#fff;
          background:#2403DF;
        }
      }
    }
    &.role3{
      .date{
        span.active{
          background:#007AFF;
        }
      }
    }
  }

</style>